import { type NestedListRowData } from '@saviynt/design-system';

import { type ViolationConflictTrackers } from '../data-layer/detailsTypes';

// Conflicts tab
type FilterMapValueType = string[] | number[] | undefined;

export const getPayload = (
  filterMap: Record<string, FilterMapValueType>,
  searchKey: string | null
) => {
  const violatingSoxCriticality = (filterMap.violatingSoxCriticality ??
    undefined) as string[];
  const violatingSysCriticality = (filterMap.violatingSysCriticality ??
    undefined) as string[];
  const violatingPrivileged = (filterMap.violatingPrivileged ??
    undefined) as string[];
  const violatingEntitlements = (filterMap.violatingEntitlements ??
    undefined) as string[];
  const assignedEntitlements = (filterMap.assignedEntitlements ??
    undefined) as string[];

  return {
    violatingSoxCriticality,
    violatingSysCriticality,
    violatingPrivileged,
    violatingEntitlements,
    assignedEntitlements,
    globalSearch: `${searchKey ?? ''}`,
  };
};

export const getHeaderTitle = (
  data: { name?: string; entitlementDisplayName?: string },
  level = 0
) => {
  if (level === 0) {
    return data.name;
  }

  if (level === 1 || level === 2) {
    return data.entitlementDisplayName;
  }

  return 'Title';
};

export const getHeaderDescription = (level = 0) => {
  if (level === 0) {
    return 'Function';
  }

  if (level === 1) {
    return 'Assigned Entitlement';
  }

  if (level === 2) {
    return 'Violating Entitlement';
  }

  return 'Description';
};

export const getHeaderIcon = (level = 0) => {
  if (level === 0) {
    return 'JobFunction';
  }

  return 'Entitlement';
};

export const closeAllNesting = (
  rows: NestedListRowData[]
): NestedListRowData[] =>
  rows.map((row) => ({
    ...row,
    isNestedRowExpanded: false,
    childRows:
      (row.data as { tracker: ViolationConflictTrackers }).tracker
        .childrenCount > 0
        ? closeAllNesting(row.childRows ?? [])
        : row.childRows,
  }));
